import { GridColDef } from "@mui/x-data-grid-pro";
import { Show } from "components";
import GKClientDataGrid from "components/GKClientDataGrid";
import { useFetchQuery } from "hooks/useQueries";
import { useParams } from "react-router-dom";
import { extraColumnsField, matchDate } from "utils/helpers";
import { moneyCommaSeparator } from "utils/MathFunction";

const AdvanceFeeHistory = () => {
  const { id } = useParams();

  const { data, isFetching } = useFetchQuery({
    key: ["GET_ADVANCE_FEE_BY_PORTFOLIO_ID"],
    route: "/api/revenue/advance-fees/",
    requestBody: {
      portfolio: id,
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Date", "date", 120, 1),
      valueFormatter: (value) => matchDate(value?.value),
    },
    {
      ...extraColumnsField("Amount (₹)", "advanceAmount", 120, 1),
      valueGetter: (row) => row?.row?.advanceAmount,
      valueFormatter: (params) => moneyCommaSeparator(params.value || 0),
      type: "number",
    },
    {
      ...extraColumnsField("Invoice No.", "invoice", 120, 1),
    },
  ];

  return (
    <Show.When
      isTrue={data?.data?.data?.length !== 0}
      showNodata
      textContent="No Advanced Fee History Available"
    >
      <GKClientDataGrid
        loading={isFetching}
        columns={columns}
        rows={data?.data?.data || []}
        name="advanceFeeHistory"
      />
    </Show.When>
  );
};

export default AdvanceFeeHistory;
